exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".main{width:100vw;height:100vh}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/autoprefixer-loader!./~/less-loader!./editor/styles/main.less
// module id = 753
// module chunks = 0